import axios from 'axios';
import config from '~/config';
import * as customError from '~/models/error'

export const useWebsiteStore = defineStore('website', {
    state: () => ({
        phraseText: []
    }),
    getters : {
        
    },
    actions: {
        getFacet(key) {
            return this.phraseText.filter(mmd => mmd.PageName  === key)
        },
        async getPhraseText(params) {
            try {
                if (!this.phraseText?.length) {
                    const url = `${config.API_BASE_URL}/api/website/GetPhraseText/`;
                    const serviceResult = await axios.get(url, { params });
                    if (!serviceResult?.data?.Data?.length)
                        throw new customError.NoContent(serviceResult, url)
                    this.phraseText = serviceResult.data.Data;
                    return this.phraseText
                } 
            } catch (err) {
                console.log({ err })
            }
        },
    },
})